<ion-header>
  <ion-toolbar *ngIf="!(online$ | async) || (servicePause$ | async)"
    [color]="!(online$ | async) ? 'danger' : 'warning'">
    <ion-buttons *ngIf="this.loggedIn$ | async" slot="start">
      <app-toggle-menu-button></app-toggle-menu-button>
    </ion-buttons>

    <ion-title class="ion-text-center" id="title">{{
      (online$ | async)
      ? (texts.error.servicePause | translate)
      : (texts.error.offline | translate)
      }}</ion-title>

    <ion-button (click)="reloadClick()" *ngIf="!(online$ | async) || (servicePause$ | async)" slot="end">
      <ion-icon name="refresh" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>